import { 
  startOfYesterday, endOfYesterday,
  startOfToday, endOfToday,
  startOfTomorrow, endOfTomorrow,
  startOfWeek, endOfWeek,
  startOfMonth, endOfMonth,
  startOfQuarter, endOfQuarter,
  startOfYear, endOfYear,
  subDays, subWeeks, subMonths, subQuarters, subYears
 } from 'date-fns';

export const PresetRanges = [
  { label: 'yesterday', value: [ startOfYesterday(), endOfYesterday() ] },
  { label: 'today', value: [ startOfToday(), endOfToday() ] },
  { label: 'tomorrow', value: [ startOfTomorrow(), endOfTomorrow() ] },
  { label: 'last_seven_days', value: [ subDays(new Date(), 7), new Date() ] },
  { label: 'last_thirty_days', value: [ subDays(new Date(), 30), new Date() ] },
  { label: 'last_week', value: [ startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }) ] },
  { label: 'this_week', value: [ startOfWeek(new Date(), { weekStartsOn: 1 }), endOfWeek(new Date(), { weekStartsOn: 1 }) ] },
  { label: 'last_month', value: [ startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1)) ] },
  { label: 'this_month', value: [ startOfMonth(new Date()), endOfMonth(new Date()) ] },
  { label: 'last_quarter', value: [ startOfQuarter(subQuarters(new Date(), 1)), endOfQuarter(subQuarters(new Date(), 1)) ] },
  { label: 'this_quarter', value: [ startOfQuarter(new Date()), endOfQuarter(new Date()) ] },
  { label: 'last_year', value: [ startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1)) ] },
  { label: 'this_year', value: [ startOfYear(new Date()), endOfYear(new Date()) ] },
];